import axiosInstance from '../../axios/axiosInstance'

export interface HistoryStoryItem {
  id: string
  prismic_uid?: string
  level: string
  /** Detailed level, e.g. BEGINNER_1, and its label, e.g. "Beginner 1". */
  story_level?: string | null
  level_display?: string | null
  step?: string
  is_read?: boolean
  opened_at: string
  last_seen_at: string
  title?: any
  english_title?: any
  image?: any
  last_publication_date?: string | null
}

export interface HistoryPage {
  items: HistoryStoryItem[]
  /** How many studied lessons the plan keeps (Free 0, Weekly and Standard 5, Pro 30).
   *  Null on a backend older than the plan gate, which is not a lock. */
  maxLimit: number | null
}

/** One page of the learner's history, or null when the request failed. */
export const getStoryHistory = async (params: {
  page: number | string
  per_page: number | string
}): Promise<HistoryPage | null> => {
  try {
    const response = await axiosInstance.get(`user-story/history`, { params })
    const maxLimit = response?.data?.max_limit
    return {
      items: response?.data?.data ?? [],
      maxLimit: typeof maxLimit === 'number' ? maxLimit : null,
    }
  } catch (error) {
    return null
  }
}
